export const DashboardData = [
    {   
        image:  "images/dashboard.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  
    },
    {   
        image:  "images/dashboard.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  

    },
    {   
        image:  "images/dashboard.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  

    },
    {   
        image:  "images/dashboard.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  
  
    },
    {   
        image:  "images/dashboard.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  
  
    },
    {   
        image:  "images/dashboard.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  

    },
]